<div>
  <h4 class="font-app-bold text-darkest text-sm md:text-base">
    {{ "paymentInfo.paymentInformation" | translate }}
  </h4>
  <div class="flex flex-col lg:flex-row lg:items-end mt-3">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "paymentInfo.paymentType" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest w-full md:text-end">{{
      paymentInformations.receiptPaymentType
    }}</span>
  </div>
  <div class="flex flex-col lg:flex-row lg:items-end mt-3">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "paymentInfo.paymentFraction" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest">{{
      paymentInformations.fractionationTypeLabel
    }}</span>
  </div>
  <div
    class="flex flex-col lg:flex-row lg:items-end mt-3"
    *ngIf="paymentInformations.fractionationTypeLabel !== fractionationTypeLabel.Annual">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "paymentInfo.paymentDate" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest w-full lg:text-end"
      >{{ "paymentInfo.the" | translate }}{{ paymentInformations.withdrawalDay }}
      {{ "paymentInfo.of" | translate }}</span
    >
  </div>
  <div class="flex flex-col lg:flex-row lg:items-end mt-3">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "paymentInfo.iban" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest w-full lg:text-end"
      >{{ paymentInformations.iban | maskIban }}
    </span>
  </div>
</div>

